<template>

<label class="d-block">{{label}}
<div class="input-group">
  <div class="input-group-prepend">
    <span class="input-group-text">
      <fa-icon :icon="icon" fixed-width />
    </span>
  </div>
  <slot name="input">
    <input v-bind="$attrs" :type="type" :value="value"  @input="$emit('input', $event.target.value)"
           :style="inputWidth ? 'flex: 0 1 '+inputWidth : ''" class="form-control"/>
    <slot name="after-input"></slot>
  </slot>
</div>
</label>

</template>

<script>

export default {
  name: 'IconInput',
  inheritAttrs: false,
  props: {
    value: {default: null},
    label: {type: String, default: ''},
    type: {type: String, default: 'text'},
    icon: {required: true},
    inputWidth: {type: String}
  }
}

</script>



// WEBPACK FOOTER //
// src/components/common/IconInput.vue